import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/qr-code-generator/QrCodeGeneratorClient.tsx");
